import script from "./OfCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./OfCampaign.vue?vue&type=script&setup=true&lang=js"

import "./OfCampaign.vue?vue&type=style&index=0&id=321c982d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321c982d"]])

export default __exports__